import type { MessageKey } from "./ru"

export const tlMessages = {
  "common.loading": "Naglo-load...",
  "common.error": "Error",
  "common.back": "Bumalik",
  "common.next": "Susunod",
  "common.search": "Maghanap",
  "auth.loginErrorTitle": "Error sa pag-login",
  "auth.openViaTelegram": "Buksan ang app sa pamamagitan ng Telegram",
  "auth.telegramRequired": "Dapat buksan ang app sa pamamagitan ng Telegram",
  "auth.authorizationError": "Error sa awtorisasyon",
  "device.rotatePortrait": "I-rotate ang device sa portrait",
  "country.brazil": "Brazil",
  "country.vietnam": "Vietnam",
  "country.egypt": "Egypt",
  "country.india": "India",
  "country.indonesia": "Indonesia",
  "country.iran": "Iran",
  "country.spain": "Spain",
  "country.italy": "Italy",
  "country.kazakhstan": "Kazakhstan",
  "country.colombia": "Colombia",
  "country.malaysia": "Malaysia",
  "country.mexico": "Mexico",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Russia",
  "country.usa": "United States",
  "country.turkey": "Türkiye",
  "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ukraine",
  "country.philippines": "Pilipinas",
  "countrySelection.chooseCountry": "Pumili ng bansa",
  "countrySelection.openAria": "Pumili ng bansa",
  "languageSelection.chooseLanguage": "Pumili ng wika",
  "commercial.direction.autotrade": "Auto Market",
  "commercial.direction.insurance": "Insurance",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Tulong sa Kalsada",
  "commercial.searchLabel": "Paghahanap sa BeepApp",
  "commercial.cityPlaceholder": "Ilagay ang lungsod",
  "commercial.emptyTitle": "Walang alok ngayon",
  "commercial.emptyLine1": "Wala pang aktibong BeepApp partner sa iyong lungsod",
  "commercial.emptyLine2": "Nagsusumikap na kaming hanapin at ikonekta sila",
  "commercial.emptyLine3": "Awtomatikong lalabas dito ang mga bagong alok",
  "commercial.helperLine1": "Ilagay ang iyong lungsod para makita",
  "commercial.helperLine2": "ang mga available na alok",
  "commercial.partnerPrompt": "Gusto mong maging BeepApp partner?",
  "commercial.apply": "Mag-apply",
  "main.admin": "Admin",
  "main.garage": "Garage",
  "main.signalSent": "Naipadala ang signal",
  "main.partnerInviteUnavailable": "Hindi available ang partner invitation",
  "main.enterPlate": "Ilagay ang plate number",
  "main.searchError": "Error sa paghahanap",
  "main.signalSendError": "Hindi naipadala ang signal",
  "main.shareCardPrefix": "Plate card",
  "main.shareLinkError": "Hindi maihanda ang link",
  "main.searchByPlateAria": "Maghanap gamit ang plate number",
  "main.russianPlateAria": "Russian plate number",
  "main.plateAria": "Plate number",
  "main.findPlateAria": "Hanapin ang plate",
  "main.loadingVehicle": "Nilo-load ang plate card…",
  "main.leaveSignal": "Mag-iwan ng signal",
  "main.share": "I-share",
  "signalSelection.chooseType": "Pumili ng uri ng signal",
  "signalSelection.category.attention": "Personal",
  "signalSelection.category.road": "Kalsada",
  "signalSelection.category.urgent": "Agad",
  "signalSelection.chooseSignal": "Pumili ng signal",
  "signalSelection.suggestOwn": "Magmungkahi ng sarili",
  "signalConfirmation.title": "Kumpirmahin ang signal",
  "signalConfirmation.plateHeading": "Suriin ang plate number",
  "signalConfirmation.signalHeading": "Suriin ang napiling signal",
  "signalConfirmation.replyTitle": "Payagan ang sagot sa Telegram",
  "signalConfirmation.replyBody": "I-on ito para makapag-message sa iyo ang may-ari ng plate\nsa Telegram. Posible lang ang sagot kung mayroon kang\n@username. Nasa may-ari ng plate ang desisyon\nkung sasagot siya.",
  "signalConfirmation.consentText": "Kinukumpirma kong tumutugma ang signal na ito\nsa totoong sitwasyon at hindi ito spam\no maling ulat.",
  "signalConfirmation.warning": "Pagkatapos ipadala, hindi na\nmaaaring baguhin ang signal",
  "signalConfirmation.sending": "Ipinapadala…",
  "signalConfirmation.send": "Ipadala",
  "partner.loadingAria": "Naglo-load",
  "partner.title": "Partner Program",
  "partner.offerLine1": "Kumita nang walang takdang panahon ng 30% sa lahat ng bayad",
  "partner.offerLine2": "ng mga user na inimbitahan mo sa BeepApp",
  "partner.offerLine3": "sa pamamagitan ng Telegram affiliate program",
  "partner.connectUnavailable": "Magiging available ang koneksyon kapag na-set up na ang Telegram Affiliate program.",
  "partner.connectTelegram": "Kumonekta sa Telegram",
  "partner.qrAria": "QR code ng partner link",
  "partner.download": "I-download",
  "partner.promoHeading": "Gumawa ng personal na promo code",
  "partner.promoHelperLine1": "Ina-activate ng promo code ang dagdag na isang taon ng subscription",
  "partner.promoHelperLine2": "at tumutulong sa pag-akit ng mga user",
  "partner.promoAria": "Promo code",
  "partner.affiliateHeading": "Iyong affiliate link",
  "partner.affiliateHelper": "I-save ang link para gumawa ng personal na QR code",
  "partner.affiliateAria": "Affiliate link",
  "partner.qrNoteLine1": "Maaaring ilagay ang QR code sa sasakyan,",
  "partner.qrNoteLine2": "sa social media at mga materyales sa advertising",
  "partner.save": "I-save",
  "partner.reset": "I-reset",
  "partner.resetConfirm": "I-reset ang naka-save na affiliate link? Mananatili sa iyo ang promo code.",
  "partner.promoFormatError": "Dapat may 4 hanggang 15 character ang promo code.",
  "partner.affiliateHostError": "t.me o telegram.me links lang ang pinapayagan.",
  "partner.affiliatePathError": "Walang Telegram path ang link.",
  "partner.affiliateFormatError": "Hindi wastong affiliate link.",
  "partner.loadError": "Error sa pag-load",
  "partner.checkInputError": "Suriin ang inilagay na impormasyon",
  "garageActivation.promoInvalid": "Hindi valid ang promo code",
  "garageActivation.plateOccupied": "Naka-link na ang plate number na ito",
  "garageActivation.activateError": "Hindi ma-activate ang Garage",
  "garageEntry.loadJournalError": "Hindi ma-load ang logbook",
  "garageEntry.loadStatusesError": "Hindi ma-load ang mga status",
  "garageEntry.activationSuccess": "Matagumpay na na-activate ang Garage",
  "garageEntry.plateAttached": "Naka-link ang plate",
  "garageEntry.attachError": "Hindi ma-link ang plate",
  "garageEntry.activationNote": "I-activate ang iyong Garage",
  "garageSheet.activationTitle": "Pag-activate ng Garage",
  "garageSheet.plateHelper": "Ilagay ang plate number ng sasakyan",
  "garageSheet.promoHelper": "May promo code ka ba?",
  "garageSheet.cleanBonusLine1": "Pagkatapos ng activation, may 1 oras ka",
  "garageSheet.cleanBonusLine2": "para sa libreng “Clean Start”",
  "garageSheet.activationFor": "Activation para sa",
  "garageSheet.cost": "Halaga",
  "garageSheet.ownerConsentLine1": "Kinukumpirma kong ako ang may-ari",
  "garageSheet.ownerConsentLine2": "ng sasakyang may nakasaad na",
  "garageSheet.ownerConsentLine3": "plate number.",
  "garageSheet.processing": "Pinoproseso...",
  "garageSheet.attach": "I-link",
  "garageSheet.pay": "Magbayad",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Pag-deactivate ng Garage",
  "garageLifecycle.cleanWarningLine1": "Mabubura ang history ng plate",
  "garageLifecycle.cleanWarningLine2": "at hindi na ito maibabalik!",
  "garageLifecycle.deactivateWarningLine1": "Pagkatapos i-deactivate, mawawala ang access",
  "garageLifecycle.deactivateWarningLine2": "sa mga feature ng aktibong Garage",
  "garageLifecycle.willBeDeleted": "MABUBURA",
  "garageLifecycle.cleanRemovedLine1": "• Lahat ng entry sa Logbook",
  "garageLifecycle.cleanRemovedLine2": "• History ng natanggap na signals",
  "garageLifecycle.cleanRemovedLine3": "• Public signal counters",
  "garageLifecycle.cleanRemovedLine4": "  sa plate card",
  "garageLifecycle.willRemain": "MANANATILI",
  "garageLifecycle.cleanPreservedLine1": "• Link ng plate sa Garage",
  "garageLifecycle.cleanPreservedLine2": "• Natitirang activation period",
  "garageLifecycle.cleanPreservedLine3": "• Napiling plate status",
  "garageLifecycle.cleanPreservedLine4": "• Kabuuang bilang ng view ng plate card",
  "garageLifecycle.freeFirstHour": "Libre sa unang oras",
  "garageLifecycle.willBecomeUnavailable": "HINDI NA MAGIGING AVAILABLE",
  "garageLifecycle.deactivateRemovedLine1": "• Logbook",
  "garageLifecycle.deactivateRemovedLine2": "• Pagpili at paggamit ng plate status",
  "garageLifecycle.deactivateRemovedLine3": "• Awtomatiko kang aalis sa AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• Auto Market",
  "garageLifecycle.deactivateRemovedLine5": "• Insurance",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Tulong sa Kalsada",
  "garageLifecycle.deactivateRemovedLine8": "• Maa-unlink ang plate number mula sa Garage",
  "garageLifecycle.willRemainAvailable": "MANANATILING AVAILABLE",
  "garageLifecycle.deactivatePreservedLine1": "• Companion",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• Paghahanap gamit ang plate number at pagtingin",
  "garageLifecycle.deactivatePreservedLine4": "  sa public vehicle card",
  "garageLifecycle.deactivatePreservedLine5": "• Kakayahang muling i-activate",
  "garageLifecycle.deactivatePreservedLine6": "  ang Garage anumang oras",
  "garageLifecycle.cleanConsentLine1": "Sumasang-ayon akong burahin",
  "garageLifecycle.cleanConsentLine2": "ang buong history ng plate na ito",
  "garageLifecycle.cleanConsentLine3": "nang walang posibilidad na maibalik.",
  "garageLifecycle.deactivateConsentLine1": "Kinukumpirma ko ang pag-deactivate at",
  "garageLifecycle.deactivateConsentLine2": "pagwawakas ng access sa lahat ng",
  "garageLifecycle.deactivateConsentLine3": "feature ng aktibong Garage.",
  "garageLifecycle.clean": "Linisin",
  "garageLifecycle.deactivate": "I-deactivate",
} satisfies Record<MessageKey, string>
